import Controller from '@ember/controller';
import Router from '@ember/routing/router';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import currency from 'currency.js';
import Settings from 'donor-elf-web/services/settings';
import { type TaskGenerator, task } from 'ember-concurrency';

export default class GoalRollingController extends Controller {
  @service declare settings: Settings;
  @service declare router: Router;

  declare model: any;
  @tracked showValidationErrors = false;
  saving = false;

  templateWillDestroy = () => {
    this.showValidationErrors = false;
    this.saving = false;
  }

  get isAnnualRollingGoal() {
    return this.settings.userSettings?.showAnnualGoal || false;
  }

  @task *save(): TaskGenerator<string> | undefined {
    if (this.saving) {
      return;
    }
    this.saving = true;
    let changeset = this.model.changeset;
    yield changeset.validate();
    this.showValidationErrors = true;
    if (changeset.get('isValid')) {
      if (this.isAnnualRollingGoal) {
        let annualGoal = changeset.get('annualGoal');
        changeset.set('monthlyGoal', currency(annualGoal).divide(12).value);
      }
      yield changeset.save();
      this.router.transitionTo('funds.fund.dashboard');
    }
    this.saving = false;
  }
}
